import React from 'react';
import { useSelector } from 'react-redux';
import LicenseMetrics from '../../licenseMetrics';
import TimelineComponent from '../../graphComponents/timelineComponent';
import RankingComponent from '../../graphComponents/rankingComponent';
import ROIComponent from '../../graphComponents/ROIComponent';
import BenchMarkingComponent from '../../graphComponents/benchMarkingComponent';
import '../../licenseAnalyticsPage/FinancePageLayout.css';
import {
  getTotalTeams,
  getTotalExpenses,
  getAdmissionFees,
  getTeamsYoyValues,
  getClubValue,
} from '../../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { shortenNumber } from '../../licenseAnalyticsSupport/calculationsUtils';
import { PAGE } from '../../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';

const TeamsLayoutPage = React.memo(() => {
  const totalTeams = useSelector(getTotalTeams);
  const totalExpenses = useSelector(getTotalExpenses);
  const admissionFees = useSelector(getAdmissionFees);
  const getYOYValues = useSelector(getTeamsYoyValues);
  const [t] = useTranslation();
  const club = useSelector(getClubValue);
  const prefix = club ? t('DC_5_CLUB') : t('AVERAGE');
  return (
    <div className="container">
      <div className="a commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('TOTAL') + ' ' + t('DC_7_COMPONENT_NAME')}
          spendValue={totalTeams || '-'}
          metricsValue={getYOYValues.value1}
          showYOY
        />
      </div>
      <div className="b commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('EXPENSE_TOTAL')}
          spendValue={shortenNumber(totalExpenses)}
          metricsValue={getYOYValues.value2}
          showYen
          showYOY
        />
      </div>
      <div className="c commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('DC_7_ADMISSION_FEES')}
          spendValue={shortenNumber(admissionFees)}
          metricsValue={getYOYValues.value3}
          showYen
          showYOY
        />
      </div>

      <div className="d commonBox">
        <TimelineComponent page={PAGE.TEAMS} departments={[]}/>
        {/* <RankingComponent page={PAGE.TEAMS} /> */}
        <RankingComponent />
      </div>
      <div className="e commonBox">
        <ROIComponent page={PAGE.TEAMS} departments={[]}/>
      </div>
      <div className="f commonBox">
        <BenchMarkingComponent page={PAGE.TEAMS} departments={[]}/>
      </div>
    </div>
  );
});

export default TeamsLayoutPage;
